module.exports = __webpack_public_path__ + "static/media/amistadlogo.978c2be4.png";